import { useMutation, useQueryClient } from "@tanstack/react-query";
import { usePostHog } from "posthog-js/react";
import { captureDashboardDeleted } from "@/lib/insights/custom-insights-analytics";
import useSelectedStores from "@lib/hooks/use-selected-stores";
import {
  deleteDashboardOnServer,
  getDashboardQueryKey,
  invalidateDashboardsListQuery,
} from "./utils";

export function useDeleteDashboard() {
  const queryClient = useQueryClient();
  const posthog = usePostHog();
  const { selectedOrganisation } = useSelectedStores();

  return useMutation({
    mutationFn: async (dashboardId: string) => {
      if (!selectedOrganisation) {
        throw new Error("Organisation ID is required");
      }

      return deleteDashboardOnServer(selectedOrganisation, dashboardId);
    },
    onSuccess: async (dashboardId) => {
      captureDashboardDeleted(posthog, {
        dashboardId,
        source: "manual",
      });

      queryClient.removeQueries({
        queryKey: getDashboardQueryKey(selectedOrganisation, dashboardId),
      });

      await invalidateDashboardsListQuery(queryClient, selectedOrganisation);
    },
  });
}
